/**
 * Created by mateo on 6/29/17.
 */
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'materiaFilter', standalone: false})

export class MateriaNivelacionesPipe implements PipeTransform {
    transform(array, materia) {
        const res = array.find(obj => `${obj.materia.nombreCompleto}` == materia);
        return res;
    }
}
